import React from 'react';
import InvoiceEmailActions from './InvoiceEmailActions';
import { printTransferPdf } from '../utils/printTransferPdf';

function InvoicePrintEmailActions({
  invoice,
  disabled = false,
  showPrint = true,
  showEmail = true,
  loading = false,
  printLabel = 'Print',
  printButtonClassName = 'button small blue',
  emailButtonClassName = 'button small blue',
  successMessage,
  onPrint,
  onSent,
  onError,
  onLoadingChange,
}) {
  const isDisabled = disabled || !invoice;

  const handlePrint = () => {
    if (isDisabled) return;
    if (onPrint) {
      onPrint(invoice);
      return;
    }
    if (Number(invoice.transactionTypeId) === 5) {
      printTransferPdf(invoice).catch(error => onError?.(error));
      return;
    }

    const printClassName = 'invoice-document-printing';
    const cleanupPrintMode = () => {
      document.body.classList.remove(printClassName);
      window.removeEventListener('afterprint', cleanupPrintMode);
    };

    document.body.classList.add(printClassName);
    window.addEventListener('afterprint', cleanupPrintMode, { once: true });

    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        try {
          window.print();
        } catch (error) {
          cleanupPrintMode();
          throw error;
        }
      });
    });
  };

  return (
    <>
      {showPrint && (
        <button
          type="button"
          className={printButtonClassName}
          onClick={handlePrint}
          disabled={isDisabled}
        >
          {printLabel}
        </button>
      )}
      {showEmail && (
        <InvoiceEmailActions
          invoice={invoice}
          disabled={isDisabled}
          loading={loading}
          buttonClassName={emailButtonClassName}
          successMessage={successMessage}
          onLoadingChange={onLoadingChange}
          onSent={onSent}
          onError={onError}
        />
      )}
    </>
  );
}

export default InvoicePrintEmailActions;
